<template>
  <div class="container-fluid vh-100 bg-cover">
    <div class="row h-100">
      <div
        class="col-12 d-flex align-items-center justify-content-center text-center"
      >
        <div>
          <div v-if="getActiveGameUser && getActiveGameUser.first_name">
            <h2>Hi</h2>
            <h1>{{ getActiveGameUser.first_name }},</h1>
            <h2>Let the</h2>
            <h2>game begin!</h2>
            <h2>&nbsp;</h2>
          </div>
          <div v-else>
            <h2>Welcome!</h2>
            <h2>Preparing your game...</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveScreen",
  computed: {
    getActiveGameUser() {
      let activeGameUser = this.$store.getters.getActiveGameUser;
      return activeGameUser;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
h1 {
  font-size: 120px;
  color: $white !important;
  padding-bottom: 20px;
  font-weight: 500;
  margin: 0;
}
h2 {
  font-size: 120px;
  color: $white !important;
  padding-bottom: 20px;
  font-weight: 500;
  margin: 0;
}
img {
  padding-bottom: 20px;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
}
.screen {
  overflow: hidden; /* Hide scrollbars */
}
</style>
